import AccountWishlistDetails from "@/components/modules/account/account-wishlist-details";
import { cn } from "@/lib/utils";
import React from "react";

type AccountWishlistProps = {
  resolution: Resolution;
};

const AccountWishlist = ({ resolution }: AccountWishlistProps) => {
  return (
    <div className={cn("text-dark-primary flex-1/2")}>
      <div className="container flex flex-col gap-10 pb-7.5 lg:flex-row lg:px-7.5 lg:pb-16">
        <AccountWishlistDetails locale={resolution?.locale} />
      </div>
    </div>
  );
};

export default AccountWishlist;
